import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { Country, Documento } from '../../../../api/interfaces/register';
import { Personal } from '../../../../api/interfaces/user';
import { RegisterService } from '../../../../api/services/register/register.service';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss']
})
export class PersonalDataComponent implements OnInit {

  disable: boolean = true;
  maxDate: Date = new Date();
  documentos: Documento[] = [];
  countrys: Country[];
  title: string = `{{ 'profile.data.personal' | translate }}`
  @Input('personalData') personalData : Personal;
  @Output() onSubmitPersonalEvent = new EventEmitter<Personal>();

  userForm = new FormGroup({
    nombre: new FormControl({ value: '', disabled: this.disable }),
    apellido: new FormControl({ value: '', disabled: this.disable }),
    segundoApellido: new FormControl({ value: '', disabled: this.disable }),
    numeroDocumento: new FormControl({ value: '', disabled: this.disable }, [Validators.pattern(/^[a-zA-Z0-9]+$/),]),
    documentoTipo: new FormControl({ value: '', disabled: this.disable}),
    fechaNacimiento: new FormControl({ value: '', disabled: this.disable }),
    pais: new FormControl({ value: '', disabled: this.disable }),
    residencia: new FormControl({ value: '', disabled: this.disable }),
  });

  
  constructor(
    private registerService: RegisterService,
    private sharedData: SharedDataService
  ) { }

  ngOnInit(): void {
    if(this.personalData.pais) {
     this.patch();
    }
    this.sharedData.currentMessage.subscribe(message => {
      if (message === "updateProfileData") {
        this.patch();
      }
    });
    this.getCountry();
    this.getTiposDocumento();
  }

  patch() {
    this.userForm.patchValue({nombre: this.personalData.nombre});
    this.userForm.patchValue({apellido: this.personalData.apellido});
    this.userForm.patchValue({segundoApellido: this.personalData.segundoApellido});
    this.userForm.patchValue({numeroDocumento: this.personalData.numeroDocumento});
    this.userForm.patchValue({documentoTipo: this.personalData.documentoTipo.documento});
    this.userForm.patchValue({fechaNacimiento : this.personalData.fechaNacimiento });
    this.userForm.patchValue({pais : this.personalData.pais.pais });
    this.userForm.patchValue({residencia: this.personalData.residencia });
  }

  edit() {
    this.disable = !this.disable;
    if(!this.disable) {
      this.userForm.controls['nombre'].enable();
      this.userForm.controls['apellido'].enable();
      this.userForm.controls['segundoApellido'].enable();
      this.userForm.controls['numeroDocumento'].enable();
      this.userForm.controls['documentoTipo'].enable();
      this.userForm.controls['pais'].enable();
      this.userForm.controls['residencia'].enable();
     
    } else {
      this.userForm.controls['nombre'].disable();
      this.userForm.controls['apellido'].disable();
      this.userForm.controls['segundoApellido'].disable();
      this.userForm.controls['numeroDocumento'].disable();
      this.userForm.controls['documentoTipo'].disable();
      this.userForm.controls['pais'].disable();
      this.userForm.controls['residencia'].disable();
    }
  }

  onSubmit() {
    this.edit();
    const indexDocumento: number = this.documentos.findIndex(documento => documento.documento == this.userForm.value.documentoTipo);
    const indexPais: number = this.countrys.findIndex(country => country.pais == this.userForm.value.pais);

    this.userForm.value.documentoTipo = this.documentos[indexDocumento];
    this.userForm.value.pais = this.countrys[indexPais];

    this.onSubmitPersonalEvent.emit(this.userForm.value);
    this.userForm.value.documentoTipo = this.documentos[indexDocumento].documento;

    this.userForm.value.pais = this.countrys[indexPais].pais;
  }

  getCountry() {
    this.registerService.getCountry()
    .subscribe(response => {
      this.countrys = response;
    },
      error => {
        console.error(error);
      });
  }

  getTiposDocumento() {
    this.registerService.getTiposDocumento()
    .subscribe(response => {
      this.documentos = response;
    },
      error => {
        console.error(error);
      });
  }

  saveCountry(country : Country) {
    this.userForm.patchValue({pais: country});
  }

}